module.exports = __webpack_public_path__ + "h5/img/chen.b28296ef.jpg";